import { SVGProps } from '@components/Icon/types';

export const Camera = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7.7002C14.7571 7.7002 17 9.94311 17 12.7002C16.9999 15.4572 14.757 17.7002 12 17.7002C9.24298 17.7002 7.00012 15.4572 7 12.7002C7 9.94311 9.24291 7.7002 12 7.7002ZM12 8.90918C9.90183 8.90918 8.20898 10.602 8.20898 12.7002C8.2091 14.7983 9.9019 16.4912 12 16.4912C14.0981 16.4912 15.7909 14.7983 15.791 12.7002C15.791 10.602 14.0982 8.90918 12 8.90918Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4004 3.30469C15.2514 3.30469 16.0416 3.74988 16.4795 4.47461L17.0811 5.4707H20.2588C21.7917 5.47077 23.0447 6.71602 23.0449 8.23926V17.9268C23.0447 19.4498 21.7923 20.6952 20.2598 20.6953H3.53613C2.00336 20.6953 0.750306 19.4506 0.75 17.9277V8.23926C0.750193 6.716 2.00321 5.47074 3.53613 5.4707H6.71387L7.31348 4.47754C7.75233 3.75072 8.54501 3.30482 9.39746 3.30469H14.4004ZM9.39746 4.66797C9.0254 4.6681 8.68159 4.86189 8.49023 5.17871L7.69043 6.50293L7.56445 6.71289L7.49121 6.83398H3.53613C2.75126 6.83402 2.12226 7.45935 2.12207 8.23926V17.9277C2.12237 18.7069 2.75121 19.332 3.53613 19.332H20.2598C21.0439 19.3319 21.6726 18.7067 21.6729 17.9268V8.23926C21.6727 7.45937 21.0436 6.83405 20.2588 6.83398H16.3037L16.2314 6.71289L15.3027 5.17578C15.112 4.86035 14.7705 4.66797 14.4004 4.66797H9.39746Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'camera';
